import { useId } from "react";

const defaultMin = 65;

export function Textarea({
  placeholder = "",
  value = "",
  onChange = () => {},
  floating = true,
  required = true,
  minHeight = defaultMin,
  autoFocus = false,
}) {
  const id = useId();

  return (
    <div className={floating ? "form-floating" : ""}>
      {!floating && (
        <label className="form-label" htmlFor={id}>
          {placeholder}
        </label>
      )}

      <textarea
        id={id}
        className="form-control"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        style={{
          minHeight: minHeight < defaultMin ? defaultMin : minHeight,
        }}
        required={required}
        autoFocus={autoFocus}
      />

      {floating && (
        <label className="form-label" htmlFor={id}>
          {placeholder}
        </label>
      )}
    </div>
  );
}
